import React, { useCallback, useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { use100vh } from "react-div-100vh";
import SignatureCanvas from "react-signature-canvas";
import Icon from "../../components/Icon";
import Card from "../../components/Card";
import { showSuccess, showError } from "../../services/toast.service";
import { getAttendanceById, saveAttendanceSignature } from "../../services/attendances.service";
import styles from "./SignaturePage.module.sass";

const SignaturePage = () => {
  const { attendanceId } = useParams();
  const heightWindow = use100vh();
  const [isSigning, setIsSigning] = useState(false);
  const [canvasWidth, setCanvasWidth] = useState(500);
  const signatureRef = useRef(null);
  const [attendance, setAttendance] = useState(null);
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  // Calculer la largeur du canvas en fonction de la taille de l'écran
  useEffect(() => {
    const updateCanvasWidth = () => {
      if (typeof window !== 'undefined') {
        const screenWidth = window.innerWidth;
        if (screenWidth < 768) {
          setCanvasWidth(Math.min(screenWidth - 100, 450));
        } else {
          setCanvasWidth(500);
        }
      }
    };

    updateCanvasWidth();
    window.addEventListener('resize', updateCanvasWidth);
    return () => window.removeEventListener('resize', updateCanvasWidth);
  }, []);

  useEffect(() => {
    const fetchAttendanceInfo = async () => {
      try {
        setLoading(true);
        const attendanceData = await getAttendanceById(attendanceId);
        setAttendance(attendanceData);
        setSession(attendanceData.expand?.session_id);
        console.log("attendanceData", attendanceData.expand?.session_id);
      } catch (error) {
        console.error('Erreur lors de la récupération des informations:', error);
        showError('Impossible de charger les informations de l\'attendance');
      } finally {
        setLoading(false);
      }
    };

    if (attendanceId) {
      fetchAttendanceInfo();
    } else {
      setLoading(false);
      showError('ID d\'attendance manquant');
    }
  }, [attendanceId]);

  const clearSignature = () => {
    if (signatureRef.current) {
      signatureRef.current.clear();
    }
  };

  const handleSignAttendance = async () => {
    if (!attendance?.id) {
      showError("Attendance non trouvée");
      return;
    }

    if (signatureRef.current?.isEmpty()) {
      showError("Veuillez signer avant de valider votre présence");
      return;
    }

    try {
      setIsSigning(true);

      const signatureDataURL = signatureRef.current.toDataURL();
      const blob = await (await fetch(signatureDataURL)).blob();
      const signatureFile = new File([blob], `signature_${attendance.id}.png`, { type: 'image/png' });

      const result = await saveAttendanceSignature(attendance.id, signatureFile);

      if (!result) {
        throw new Error("Échec de la sauvegarde de la signature");
      }

      showSuccess("Signature enregistrée avec succès");

      setTimeout(() => {
        window.location.href = "/student/dashboard";
      }, 1500);

    } catch (error) {
      showError(`Erreur: ${error.message}`);
    } finally {
      setIsSigning(false);
    }
  };

  return (

    <>
      <div className={styles.shop}>
        <div className={styles.background}>
          <img src="/images/content/bg-shop.jpg" alt="Background" />
        </div>
        <div className={styles.modal} >
          <div className={styles.outer} >
              <Card
                    className={styles.card}
                    title="Signer votre présence"
                    classTitle="title-blue"
                >
              <div className={styles.description} style={{
                maxHeight: 'calc(80vh - 120px)',
                overflowY: 'auto',
                paddingRight: '10px'
              }}>

                {/* Zone de signature */}
                <div className={styles.signatureSection} style={{ marginBottom: '30px' }}>
                  <p style={{ marginBottom: '15px' }}>
                    Merci d'entrer votre signature dans la box ci-dessous :
                  </p>

                  <div className={styles.signatureContainer} style={{
                    position: 'relative',
                    backgroundColor: 'white',
                    border: '1px solid #ddd',
                    borderRadius: '4px'
                  }}>
                    <SignatureCanvas
                      ref={signatureRef}
                      canvasProps={{
                        width: canvasWidth,
                        height: 200,
                        className: styles.signatureCanvas,
                        style: {
                          backgroundColor: 'white',
                          cursor: 'crosshair',
                          borderRadius: '4px',
                          maxWidth: '100%'
                        }
                      }}
                    />

                    {/* Texte "SIGNEZ ICI" en arrière-plan */}
                    <div style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      fontSize: '24px',
                      color: '#f0f0f0',
                      fontWeight: 'normal',
                      pointerEvents: 'none',
                      zIndex: 0,
                      opacity: 0.6
                    }}>
                      SIGNEZ ICI
                    </div>

                    {/* Bouton croix pour effacer - style modal */}
                    <button
                      type="button"
                      onClick={clearSignature}
                      className={styles.close}
                      style={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                        zIndex: 10
                      }}
                      title="Effacer la signature"
                    >
                      <Icon name="close" size="20" />
                    </button>
                  </div>
                </div>









                {attendance && session && (
                  <div className={styles.sessionInfo} style={{ marginBottom: '20px' }}>
                    <p style={{ textAlign: 'center' }}>
                      J'atteste signer en tant que {attendance.expand?.participant_id?.first_name} {attendance.expand?.participant_id?.last_name} pour la session :<br />
                      {session.expand?.formation_id?.qualification_title || session.title || 'Session de formation'}<br />
                      {session.start_date && (
                        <>
                          le {new Date(session.start_date).toLocaleDateString('fr-FR')} à {new Date(session.start_date).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                        </>
                      )}
                    </p>
                  </div>
                )}

                <div className={styles.btnWrap} style={{ marginTop: '40px', display: 'flex', justifyContent: 'flex-end' }}>
                  <button
                    className="button-blue"
                    onClick={handleSignAttendance}
                    disabled={isSigning}
                    style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}
                  >
                    {isSigning ? (
                      <>
                        Signature en cours...
                      </>
                    ) : (
                      <>
                        Confirmer ma présence
                      </>
                    )}
                  </button>
                </div>

              </div>
            </Card>
          </div>
        </div>
      </div>

    </>
  );
};

export default SignaturePage;